<script>
/**
 * Descripción: componente Layout para pags de Error y Login
 *
 * @displayName TheError
 */

export default {
  name: 'TheError',

  data() {
    return {
      /**
       * Tamaño de la pantalla del dispositivo
       */
      windowSize: {
        x: 0,
        y: 0
      },

      img: null
    };
  },

  mounted() {
    /**
     * Determinar que tipo de buscadores utilizar
     */
    this.onResize();
  },

  methods: {
    /**
     * Determinar que tipo de buscadores utilizar
     */
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };

      this.windowSize.x > 959 && this.windowSize.y >= 625
        ? (this.img = true)
        : (this.img = false);
    }
  }
};
</script>

<template>
  <v-container
    class="text-center"
    fill-height
    style="height: calc(100vh - 58px);"
    v-resize="onResize"
  >
    <img class="wave" src="@/assets/loginBackground.png" v-if="img" />
    <v-row align="center" justify="center" v-if="img">
      <v-col cols="5" md="5" sm="12" class="d-sx-none d-sm-none d-md-flex">
        <!-- @slot Use este slot para la img -->
        <slot name="Img"></slot>
      </v-col>
      <v-spacer />
      <v-col cols="6" md="6" sm="12">
        <!-- @slot Use este slot para el contenido -->
        <slot name="RenderBody"></slot>
        <br />
      </v-col>
      <v-footer absolute class="font-weight-medium">
        <v-layout align-end justify-end>
          <img src="@/assets/LogoMDG.png" height="100px" />
        </v-layout>
      </v-footer>
    </v-row>

    <v-row align="center" justify="center" v-else>
      <v-col cols="12">
        <!-- @slot Use este slot para el contenido -->
        <slot name="RenderBody"></slot>
        <br />
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.wave {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 100%;
}

.theme--light.v-footer {
  background-color: transparent;
}
</style>
